import { render, staticRenderFns } from "./AdminActiveProjects.vue?vue&type=template&id=142bf473&scoped=true&"
import script from "./AdminActiveProjects.vue?vue&type=script&lang=js&"
export * from "./AdminActiveProjects.vue?vue&type=script&lang=js&"
import style0 from "./AdminActiveProjects.vue?vue&type=style&index=0&id=142bf473&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "142bf473",
  null
  
)

export default component.exports